import { useGetCurrentUserQuery } from 'services';
import { BillingPlan } from 'shared/models';

export const useIsExpired = () => {
	const { data } = useGetCurrentUserQuery();

	return data && data.billing_plan === BillingPlan.EXPIRED;
};
